/*
 * Get History
 - - - - - - - - - - - - - -
 Returns a history object containing information about which page the user came from.
 */

import { createBrowserHistory } from "history";

export const history = createBrowserHistory();
